import { useListView } from '../../core/ListViewProvider'
import { LogsListToolbar } from './LogsListToolbar'
import { LogsListSearchComponent } from './LogsListSearchComponent'

/**
 * El componente UsuariosEncabezados muestra el buscador, 
 * también muestra el filtro, exportar archivo y agregar usuario,
 * en caso de seleccionar elemento(s) no muestra lo anterior 
 * pero si el buscador, el número de elementos seleccionados y el boton de eliminar 
 * los elementos seleccionados 
 */
const LogsEncabezados = () => {
  const { selected } = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <LogsListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        <LogsListToolbar />
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export { LogsEncabezados }
